import { atom } from 'jotai';
import z from 'zod';

export const ZSelectedPaymentMethodSchema = z.object({
  type: z.string(),
});

export type SelectedPaymentMethodAtom = z.infer<typeof ZSelectedPaymentMethodSchema>;

export const selectedPaymentMethodAtom = atom<SelectedPaymentMethodAtom>({
  type: 'card',
});
